export const TRY_AND_BUY_ROUTE = '/dashboard/try-and-buy';
export const DASHBOARD = '/dashboard/summary';
export const numberListFilters = ['aamali'];
export const fbbTyeFilter = ['fbb'];
export const filterTypeService = 'service';
